module.exports = __webpack_public_path__ + "img/10.5.COD.bba93fa8.png";